import * as React from 'react';
import { IBuilderStatsSchema } from '../../repositories/newbuilding-card/entities/builder/BuilderStatsSchema';
import { StatItem } from './parts/StatItem';
import * as styles from './Stats.css';

interface IStatsProps {
  stats?: IBuilderStatsSchema | null;
}

export const Stats: React.FC<IStatsProps> = props => {
  const { stats } = props;

  if (!stats) {
    return null;
  }

  return (
    <div className={styles['wrapper']}>
      {stats.inProgress && (
        <StatItem statusLabel={'Строится '} qs={stats.inProgress.qs} text={stats.inProgress.housesText} />
      )}
      {stats.done && <StatItem statusLabel={'Сдано '} qs={stats.done.qs} text={stats.done.housesText} />}
    </div>
  );
};
